<script setup lang="ts">
import { ConnectedAccountsEmbed } from '@/Pejer/tables/ConnectedAccounts'
import { ArrowRight } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import { Dialog, DialogContent, DialogTrigger } from 'pejer/src/components/ui/dialog'
import { computed, ref } from 'vue'
import AccountSetupContent from './AccountSetupContent.vue'

const props = defineProps<{
  connectedAccount: ConnectedAccountsEmbed.ListItem
}>()

const missingSignature = computed(
  () => !props.connectedAccount.signatureCompletedAt && !!props.connectedAccount.tosAcceptedAt
)

const modalOpen = ref(false)
</script>
<template>
  <Dialog @update:open="modalOpen = $event" v-model:open="modalOpen">
    <DialogTrigger as-child>
      <slot>
        <Button
          @click.prevent.stop
          variant="ghost"
          class="p-1 h-6 hover:bg-gray-200 rounded-sm group text-gray-600"
        >
          <ArrowRight class="group-hover:scale-110" :size="16" />
        </Button>
      </slot>
    </DialogTrigger>
    <DialogContent
      class="max-w-[calc(100vw-20px)] w-fit max-h-[calc(100vh-50px)] flex flex-col p-8"
      :class="{
        'w-full': missingSignature,
      }"
    >
      <AccountSetupContent
        :connected-account="connectedAccount"
        in-dialog
        :active="modalOpen"
        @close="modalOpen = false"
      />
    </DialogContent>
  </Dialog>
</template>
